import {Component, OnDestroy, OnInit} from '@angular/core';
import { MyFormService } from "@services/landing/my-form.service";
import { MyFormClass } from "@classes/myForm.class";
import { TabCells } from "@classes/abstract.class";
import { Images } from "@constants/images";
import { TranslatePipe } from "@pipes/translate/translate.pipe";
import {Subscription} from "rxjs";
import {LanguageFacade} from "@redux/facades/language.facade";

@Component({
  standalone: false,
  selector: 'app-form',
  templateUrl: './form.component.html',
  styleUrls: ['./form.component.scss']
})
export class FormComponent implements OnInit, OnDestroy {
  public lang: string = 'en';
  public images = Images;
  public tabSelected: number = 1;
  public backgroundPrint: string = '';
  public imagesQR: string = this.images.imageQR;
  public userName: string = '';
  public showPopup: boolean = false;
  public isMobile: boolean = false;
  public unsubscribeLanguage: Subscription;

  constructor(
    public myFormClass: MyFormClass,
    public myFormService: MyFormService,
    public myTranslatePipe: TranslatePipe,
    public languageFacade: LanguageFacade
  ) {
    if (window.innerWidth < 577) {
      this.tabSelected = 0;
      this.isMobile = true;
    }
    this.unsubscribeLanguage = this.languageFacade.languageState$.subscribe(
      ok => {
        this.lang = ok.selected;
      }
    );
  }

  // tslint:disable-next-line:typedef
  ngOnInit(): any {
  }

  // tslint:disable-next-line:typedef
  ngOnDestroy() {
    const self = this;
    self.unsubscribeLanguage.unsubscribe();
  }

  public isCompleteTab = (tab: TabCells): boolean => {
    let completed = true
    const model: any = this.myFormClass.model;
    const inputs = tab.cells.filter(t => t.required);
    inputs.map((item => {
      if (completed) {
        if (item.cellType === 'checkbox') {
          const value = model[item.name];
          if (value === false) completed = false;
        } else if (item.cellType === 'text') {
          const value = model[item.name];
          if (value.length === 0) completed = false;
        } else if (item.cellType === 'date') {
          const value = model[item.name];
          if (value === null) completed = false;
        } else if (item.cellType === 'number') {
          const value = model[item.name];
          if (value === '' || value === null || value === 0) completed = false;
        } else if (item.cellType === 'signature') {
          const value = model[item.name];
          if (value.height === 0) completed = false;
        }
      }
    }));
    return completed;
  }

  public nextStep = (tabNumber: number) => {
    this.tabSelected = tabNumber;
  }

  public sendForm = () => {
    this.myFormService.sendForm(this.myFormClass.model).then(
      (data) => {
        if (data === true) {
          this.imagesQR = this.myFormService.data;
          this.userName = this.myFormClass.model['full_name']
          this.showPopup = true;
        }
      }
    );
  }

  public print = () => {
    var prtContent = document.createElement("div");
    if (prtContent) {
      var WinPrint = window.open('', '_blank', 'left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0');
      if (WinPrint) {
        // Header
        if (this.lang === 'en') {
          this.backgroundPrint = this.images.header2_en;
        } else if (this.lang === 'es') {
          this.backgroundPrint = this.images.header2_es;
        }
        const headerDiv = document.createElement('div');
        headerDiv.setAttribute('style', 'position: relative; display: block; text-align: center; max-width: 1440px; margin: auto;');
        const headerIMG = document.createElement('img');
        headerIMG.src = this.backgroundPrint;
        headerIMG.setAttribute('style', 'width: 100%; height: auto;');
        headerDiv.append(headerIMG);
        // Popup
        const popUPDiv = document.createElement('div');
        popUPDiv.setAttribute('style', 'display: flex; flex-direction: row; justify-content: center; align-items: center; width: 100vw; height: 600px;');
        const popUP = document.createElement('div');
        popUP.setAttribute('style', 'width: 90%; max-width: 415px; height: auto; border: 1px solid #000; padding: 20px; border-radius: 12px; -webkit-border-radius: 12px; -moz-border-radius: 12px; background-color: #fff; display: flex; flex-direction: column; justify-content: center; align-items: center; z-index: 1; position: relative;');
        // Face
        const faceDiv = document.createElement('div');
        faceDiv.setAttribute('style', 'margin-top: 20px; width: 72px; height: 72px;');
        const face = document.createElement('img');
        face.src = this.images.face;
        face.setAttribute('style', 'width: 100%; height: auto;');
        faceDiv.append(face);
        // Title
        const title = document.createElement('h1');
        title.innerText = this.myTranslatePipe.transform('landing.form.date_registered');
        title.setAttribute('style', 'width: 90%; margin: 30px auto; font-family: SamsungSharpSansBold; font-size: 24px; font-weight: bold; font-stretch: normal; font-style: normal; line-height: 1; letter-spacing: normal; text-align: center; color: #1332a6;');
        // QR
        const qrDiv = document.createElement('div');
        qrDiv.setAttribute('style', 'width: 170px; height: 170px; display: block;');
        const qr = document.createElement('img');
        qr.src = this.imagesQR;
        qr.setAttribute('style', 'width: 100%; height: auto;');
        qrDiv.append(qr);
        // Text
        const text = document.createElement('p');
        text.innerHTML = this.userName + '<br>' + this.myTranslatePipe.transform('landing.form.uses');
        text.setAttribute('style', 'width: 90%; margin: 28px auto; font-family: SamsungOne-500; font-size: 16px; font-weight: 500; font-stretch: normal; font-style: normal; line-height: 1; letter-spacing: normal; text-align: center; color: #222;');
        //
        popUP.append(faceDiv);
        popUP.append(title);
        popUP.append(qrDiv);
        popUP.append(text);
        popUPDiv.append(popUP);
        prtContent.append(headerDiv);
        prtContent.append(popUPDiv);
        WinPrint.document.write(prtContent.innerHTML);
        WinPrint.document.close();
        WinPrint.focus();
        WinPrint.print();
      }
    }
  }

  public close = () => {
    location.reload();
  }
}
